/* eslint-disable indent */
import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import isEmpty from "../../../validation/isEmpty";
import { tableSkeleton } from "../../../constant/helper/helper";
import PropTypes from "prop-types";

const MyLeaveList = ({ hrLoading, leaveListData }) => {
  if (hrLoading) {
    return <tr>{tableSkeleton(11)}</tr>;
  } else if (!isEmpty(leaveListData)) {
    return leaveListData.map((detailLeave, index) => (
      <tr key={index} style={{ fontSize: "12px" }}>
        <td>
          <span className="">{index + 1}</span>
        </td>

        <td>
          <span className="">{detailLeave.workerId}</span>
        </td>
        <td>
          <Link to={`/hr/user/all-users/${detailLeave.employeeId}`}>
            {detailLeave.workerFullName}
          </Link>
        </td>
        <td>
          <span className="">{detailLeave.leaveType}</span>
        </td>
        <td>
          <span className="">{detailLeave.leaveReason}</span>
        </td>
        <td>
          <span className="">
            {moment(detailLeave.leaveFrom).format("DD-MM-YYYY")}
          </span>
        </td>
        <td>
          <span className="">
            {moment(detailLeave.leaveTo).format("DD-MM-YYYY")}
          </span>
        </td>
        <td>
          <span className="">{detailLeave.numberOfDays}</span>
        </td>

        <td>
          <span className="">
            {moment(detailLeave.createdAt).format("DD-MM-YYYY")}
          </span>
        </td>
        <td>
          <span
            className={
              detailLeave.leaveStatus === "APPLIED"
                ? "badge badge-info text-white"
                : detailLeave.leaveStatus === "APPROVED"
                ? "badge badge-success text-white"
                : detailLeave.leaveStatus === "REJECTED"
                ? "badge badge-danger text-white"
                : detailLeave.leaveStatus === "HOLD"
                ? "badge badge-warning text-white"
                : "badge badge-success text-white"
            }
          >
            {detailLeave.leaveStatus}
          </span>
        </td>
      </tr>
    ));
  } else {
    return <></>;
  }
};

MyLeaveList.propTypes = {
  hrLoading: PropTypes.bool.isRequired,
  leaveListData: PropTypes.array.isRequired
};

export default MyLeaveList;
